import { apiGet, apiPatch } from '../../../shared/api-client/index.js';

export type TelegramOutboundSubscription = {
  type: 'approval_result' | 'daily_digest';
  enabled: boolean;
  locale: 'ru' | 'en';
  timezone: string | null;
  localMinuteOfDay: number | null;
  nextDueAt: string | null;
  stateVersion: number | null;
};

export interface TelegramOutboundSettings {
  available: boolean;
  capabilities: { approvalResults: boolean; dailyDigest: boolean };
  approvalResult: TelegramOutboundSubscription;
  dailyDigest: TelegramOutboundSubscription;
}

export interface UpdateTelegramOutboundSubscription {
  type: 'approval_result' | 'daily_digest';
  enabled: boolean;
  expectedStateVersion: number | null;
  locale: 'ru' | 'en';
  timezone?: string;
  localMinuteOfDay?: number;
}

export const telegramOutboundQueryKey = (workspaceId: string) =>
  ['telegram-outbound-subscriptions', workspaceId] as const;

export const getTelegramOutboundSettings = (): Promise<TelegramOutboundSettings> =>
  apiGet('/telegram/outbound-subscriptions');

export const patchTelegramOutboundSubscription = (
  input: UpdateTelegramOutboundSubscription,
): Promise<TelegramOutboundSettings> => apiPatch('/telegram/outbound-subscriptions', input);
